import axios from "axios";
import { basePartnerManagement } from "src/config";
import { msalInstance } from "src/lib/msal";
import z from "zod";

const partnerManagementInstance = axios.create({
    baseURL: basePartnerManagement,
});

// AUTHENTICATION
partnerManagementInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// SCHEMAS
const trackingPartnerSchema = z.object({
    Id: z.number().nullable(),
    Partner: z.string(),
    CustomerCode: z.string(),
    Requestor: z.string().nullable(),
    Status: z.string(),
    Active: z.boolean(),
    BOLRegex: z.string().nullable(),
    BOLLocation: z.string().nullable(),
    BOLType: z.string().nullable(),
    ReferenceKey: z.string().nullable(),
    Author: z.string().nullable(),
    ModifiedAt: z.string().nullable(),
});
const partnerArraySchema = z.array(trackingPartnerSchema);
export type TrackingPartner = z.infer<typeof trackingPartnerSchema>;

const objectResultSchema = z.object({
    status: z.number(),
    statusText: z.string(),
});
export type objectResult = z.infer<typeof objectResultSchema>;

// GET
export async function GetTrackingPartners(partner: string, search: string) {
    const response = await partnerManagementInstance.get(
        `/get-partners/${partner}/${search}`,
    );
    const data = partnerArraySchema.parse(response.data);
    return data;
}

// PATCH
export async function SetTrackingPartner(
    author: string,
    partnerId: number | null,
    partner: TrackingPartner,
) {
    const response = await partnerManagementInstance.patch(
        `/set-partner/${author}/${partnerId}`,
        partner,
    );
    console.log(response);
    const data = objectResultSchema.parse(response);
    console.log(data);

    return data;
}

// GET HISTORY
export async function GetCustomerHistory(Id: number | null) {
    console.log(Id);
    const response = await partnerManagementInstance.get(`/get-history/${Id}`);
    console.log(response);
    const data = partnerArraySchema.parse(response.data);
    return data;
}

const vendorSchema = z.object({
    TrackingPartner: z.string(),
    DisplayName: z.string(),
});
const vendorArraySchema = z.array(vendorSchema);

// GET VENDORS
export async function GetVendors() {
    const response = await partnerManagementInstance.get(`/get-vendors`);
    const data = vendorArraySchema.parse(response.data);
    return data;
}
